import React from 'react';

export const TITLE = [
  {
    textSize: '6rem',
    textType: 'h1',
    marginBottom: '3.25rem',
    textMobile: '2.2rem',
    renderContent: () => <span>¿QUIÉNES SOMOS?</span>,
  },
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>
        En KUTER convertimos ideas en imágenes que impactan.
        <br />
        Somos un estudio creativo con más de 20 años desarrollando historias que
        combinan dirección artística, narrativa visual y ejecución técnica de
        alto nivel.
        <br />
        <br />
        Creemos en el poder del concepto bien realizado.
        <br />
        <br />
        Por eso diseñamos cada proyecto desde su raíz: proponemos, imaginamos y
        dirigimos con visión estratégica, control creativo y estética precisa.
        <br />
        <br />
        Integramos talento creativo y producción audiovisual in-house para
        construir imágenes con una mirada contemporánea, ágil y cinematográfica.
        <br />
        <br />
        Imagina.
        <br />
        Realiza.
        <br />
        <br />
        Eso es KUTER. Una sola idea puede cambiarlo todo.
      </span>
    ),
  },
];
